export const CALL_AI_COMPANY_SETTINGS_QUERY = `query CallaiCompanySettings($cname:String!) {
  getTenantByMtCname(cname:$cname) {
    id
    name
  }
  getFeatureFlags {
    name
    isEnabledForTenant
    active
  }
  getCallAIBaseUrl {
    url
  }
}`;

export const CALL_AI_USER_DATA_QUERY = `query GetUserData($domain: String!, $isEmbeddedNative: Boolean = false, $shouldSkipBrandColor: Boolean = false) {
  auth {
    user {
      id
      name @skip(if: $isEmbeddedNative)
      email @skip(if: $isEmbeddedNative)
      imageUrl
      isAdmin
      isManager
      hasExternalRecordings
      firstLoginTime
      roles
      calendars {
        type
        isIntegrated
        emails {
          state
          email
        }
      }
      languages {
        id
        displayName
      }
      teamPerson {
        id
        name
        emails
        phones
        user {
          id
        }
      }
      userPreferences
      manager
      permissions {
        subject
        action
      }
    }
  }
  domain(domain: $domain) {
    id
    name
    logoUrl
    botEmail
    mtCname @skip(if: $isEmbeddedNative)
    domainEmails
    noManagersYetInCompany
    mindtickleSettings {
      domain @skip(if: $isEmbeddedNative)
      whiteLabelledDomain
      isCoachingEnabled @skip(if: $isEmbeddedNative)
      enableCallGPT @skip(if: $isEmbeddedNative)
      enableAiForCompany
      enableKeyMoments
      enableActionItems
    }
    companySettings {
      mtSsoEnable
      calendarType
      calendarPopupSkippable
      exportForContent
      brandColor @skip(if: $shouldSkipBrandColor)
      externalCallShareEnable
      callScoreEnable
      fiscalMonth
      managerInsightsEnabled
      callScoreVisibleToReps
      winningBehaviourByRole
      meetingInternalAccessPolicy
      record
      disableRecordingForDomains
      rpToggleNotification
      allowDownloadRecording
      impromptuMeetingEnabled
    }
    languageSettings {
      multiLanguageSupport
      languagePreferences {
        id
        displayName
      }
    }
  }
}`;
